import React from "react";

const Footer = () => {
  return (
    <footer
      style={{
        background: "#181a1b",
        color: "#e0e0e0",
        padding: "2rem 1rem 1rem 1rem",
        textAlign: "center",
        borderTop: "1px solid #222",
        width: "100%",
        marginTop: "auto"
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "center",
          gap: "1.5rem",
          marginBottom: "1rem"
        }}
      >
        <a href="/o-nas" style={linkStyle}>O nás</a>
        <a href="/ochrana-udaju" style={linkStyle}>Ochrana osobních údajů</a>
        <a href="/cookies" style={linkStyle}>Cookies</a>
        <button onClick={openCookieSettings} style={{...linkStyle, background: "none", border: "none", cursor: "pointer", padding: 0}}>Nastavení cookies</button>
        <a href="mailto:info@matikamistr.cz" style={linkStyle}>Kontakt</a>
      </div>
      <div style={{ fontSize: "0.95rem", opacity: 0.7 }}>
        Copyright © 2025 MatikaMistr.
      </div>
    </footer>
  );
};

const linkStyle = {
  color: "#e0e0e0",
  textDecoration: "none",
  fontWeight: 500,
  fontSize: "1rem",
  transition: "color 0.2s",
  padding: "0.25rem 0.5rem"
};

function openCookieSettings() {
  // Pokus o vyvolání banneru/modal okna přes custom event
  window.dispatchEvent(new CustomEvent("openCookieSettings"));
}

export default Footer;
